import qconsole from 'scripts/lib/qconsole';

export default function createConfigurationGatewayObserver(Model, store, context) {
  class ConfigurationGatewayObserver {
    constructor(context) {
      this.context = context;
    }

    handleFetchConfiguration(configurationDto) {
      this.context.stores[store].resetPending();
      this.context.stores[store].set(Model.fromJs(configurationDto));
    }

    handleFetchConfigurationError(errorDto) {
      qconsole.log(`Failed to fetch '${Model.name}': ${JSON.stringify(errorDto)}`);
    }

    handleConfigurationDelete() {
      this.context.stores[store].remove();
    }

    handleDeleteErrors(errorDto) {
      qconsole.log(`Failed to delete '${Model.name}': ${JSON.stringify(errorDto)}`);
    }

    handleConfigurationUpdate(configurationDto) {
      qconsole.log(`Updated configuration for '${Model.name}'`);
    }

    handleUpdateErrors(errorDto) {
      qconsole.log(`Failed to update '${Model.name}': ${JSON.stringify(errorDto)}`);
    }
  }

  return new ConfigurationGatewayObserver(context);
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/configuration/create_configuration_gateway_observer.js